export default "__VITE_ASSET__7dd82422__"